import R from 'ramda'

import getInitialState from 'Common/utils/getInitialState'

import MenuSelect from '../extensions/MenuSelect'
import {
  cefr,
  clb,
  eld,
  nrs,
  eslLevelSort,
  eldLevelSort,
  nrsLevelSort,
  levelFiltersByPreference,
  none,
} from '../../constants/levels'

const ascendByLabel = R.ascend(
  R.compose(
    R.toLower,
    R.prop('label')
  )
)

const ascendByParsedLabel = R.ascend(x => parseInt(R.prop('label', x), 10))

const ascendByEslLevelValue = R.ascend(x => eslLevelSort[R.prop('label', x)])
const ascendByEldLevelValue = R.ascend(x => eldLevelSort[R.prop('label', x)])
const ascendByNrsLevelValue = R.ascend(x => nrsLevelSort[R.prop('label', x)])

const formatLevelsByPreference = {
  [cefr]: items =>
    R.sort(ascendByLabel, items).map(item => ({
      ...item,
      label: `CEFR ${item.label}`,
    })),
  [clb]: items =>
    R.sort(ascendByParsedLabel, items).map(item => ({
      ...item,
      label: `CLB ${item.label}`,
    })),
  [eld]: items => R.sort(ascendByEldLevelValue, items),
  [nrs]: items =>
    R.sort(ascendByNrsLevelValue, items).map(item => ({
      ...item,
      label: `NRS ${item.label}`,
    })),
  [none]: items => R.sort(ascendByEslLevelValue, items),
}

export default function LevelFilter() {
  const { levelPreference } = getInitialState()

  return (
    <MenuSelect
      label='Level'
      icon='lightbulb'
      attribute={levelFiltersByPreference[levelPreference]}
      transformItems={formatLevelsByPreference[levelPreference]}
      defaultRefinement=''
    />
  )
}
